import LegalLayout from "./LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout eyebrow="Rechtliches" title="Datenschutzerklärung">
      <p>
        Stand: Februar 2026. Wir nehmen den Schutz deiner persönlichen Daten
        sehr ernst und behandeln diese vertraulich sowie entsprechend der
        gesetzlichen Datenschutzvorschriften (DSGVO, BDSG) und dieser
        Datenschutzerklärung.
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
        <br />
        <br />
        <strong>Erik Schrum</strong>
        <br />
        Langenkamp 18
        <br />
        23743 Grömitz
        <br />
        Deutschland
        <br />
        E-Mail:{" "}
        <a href="mailto:info@norrbyte.de">info@norrbyte.de</a>
      </p>

      <h2>2. Hosting & Server-Logs</h2>
      <p>
        Diese Anwendung wird auf der Infrastruktur von{" "}
        <strong>Emergent (emergent.sh)</strong> gehostet. Beim Aufruf der App
        werden technisch notwendige Daten (z. B. IP-Adresse, Browser-Typ,
        Zeitpunkt, abgerufene Ressource) in Server-Logfiles verarbeitet. Die
        Verarbeitung erfolgt auf Basis unseres berechtigten Interesses an einer
        stabilen und sicheren Bereitstellung der App gemäß Art. 6 Abs. 1 lit. f
        DSGVO.
      </p>

      <h2>3. Lokale Speicherung (localStorage) — keine Cookies</h2>
      <p>
        PromptKiste AI nutzt <strong>keine Tracking-Cookies</strong>. Für die
        Funktion der App speichern wir ausschließlich im{" "}
        <strong>localStorage deines Browsers</strong> folgende Werte direkt auf
        deinem Gerät:
      </p>
      <ul>
        <li>
          <strong>promptkiste:usage</strong> – Anzahl & Datum deiner heutigen
          Generierungen (nötig für das Free-Tageslimit).
        </li>
        <li>
          <strong>promptkiste-premium</strong> – Flag, ob du Premium
          freigeschaltet hast.
        </li>
        <li>
          <strong>promptkiste:install-dismissed</strong> – Markierung, dass du
          den Install-Hinweis ausgeblendet hast.
        </li>
      </ul>
      <p>
        Diese Daten verlassen dein Gerät nicht und werden nicht an uns
        übermittelt. Du kannst sie jederzeit in deinen Browser-Einstellungen
        löschen.
      </p>

      <h2>4. Prompt-Generierung</h2>
      <p>
        Die Erstellung der Suno-Prompts erfolgt im MVP{" "}
        <strong>vollständig lokal in deinem Browser</strong> auf Basis von
        Vorlagen. Es werden keine Eingaben (Genre, Stimmung, Zusatzwünsche
        etc.) an unsere Server oder Dritte gesendet.
      </p>

      <h2>5. Zahlungsabwicklung über Digistore24</h2>
      <p>
        Beim Kauf eines kostenpflichtigen Plans (Pro / Business) wirst du an{" "}
        <strong>Digistore24.com</strong> weitergeleitet. Die gesamte
        Zahlungsabwicklung — inkl. Erhebung, Speicherung und Verarbeitung
        deiner Bezahl- und Rechnungsdaten — erfolgt durch die{" "}
        <strong>Digistore24 GmbH</strong>, St.-Godehard-Straße 32, 31139
        Hildesheim, als eigenständig Verantwortliche / Reseller. Es gelten die
        Datenschutzbestimmungen von Digistore24:{" "}
        <a
          href="https://www.digistore24.com/page/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          digistore24.com/page/privacy
        </a>
        . Wir selbst erhalten von Digistore24 lediglich die für die
        Vertragsabwicklung erforderlichen Informationen.
      </p>

      <h2>6. Eingebundene Drittanbieter</h2>
      <h3>6.1 Google Fonts</h3>
      <p>
        Wir laden Schriftarten („Outfit", „Figtree", „JetBrains Mono") von den
        Google-Fonts-Servern (Google Ireland Limited, Gordon House, Barrow
        Street, Dublin 4, Irland). Dabei wird deine IP-Adresse an Google
        übertragen. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
        Interesse an einheitlicher Darstellung).
      </p>

      <h3>6.2 Unsplash</h3>
      <p>
        Im Hero-Bereich wird ein Bild von{" "}
        <a
          href="https://unsplash.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          unsplash.com
        </a>{" "}
        (Unsplash Inc., Kanada) geladen. Auch hier wird deine IP-Adresse an
        Unsplash übertragen. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
      </p>

      <h3>6.3 PostHog (Produkt-Analytics)</h3>
      <p>
        Zur Verbesserung der App nutzen wir{" "}
        <a
          href="https://posthog.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          PostHog
        </a>{" "}
        (PostHog Inc., USA) in pseudonymisierter Form. PostHog erhebt
        anonymisierte Nutzungs-Statistiken (z. B. Klick-Events, Seitenaufrufe).
        Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
        Produktverbesserung). Du kannst die Erhebung jederzeit über deine
        Browser-Einstellungen (z. B. DoNotTrack, Tracking-Blocker) verhindern.
      </p>

      <h2>7. Progressive Web App (PWA)</h2>
      <p>
        PromptKiste AI ist als installierbare PWA verfügbar. Wenn du die App
        auf deinem Gerät installierst, werden statische App-Dateien
        (Service-Worker-Cache) lokal in deinem Browser gespeichert, um schnelle
        Ladezeiten und Offline-Fähigkeit der Startseite zu ermöglichen. Es
        werden dabei keine personenbezogenen Daten übertragen.
      </p>

      <h2>8. Deine Rechte</h2>
      <p>Du hast jederzeit das Recht auf:</p>
      <ul>
        <li>Auskunft (Art. 15 DSGVO)</li>
        <li>Berichtigung (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        <li>
          Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO), z. B. dem
          Landesbeauftragten für Datenschutz Schleswig-Holstein.
        </li>
      </ul>
      <p>
        Sende deine Anfrage einfach per E-Mail an{" "}
        <a href="mailto:info@norrbyte.de">info@norrbyte.de</a>.
      </p>

      <h2>9. SSL-/TLS-Verschlüsselung</h2>
      <p>
        Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung.
        Du erkennst eine verschlüsselte Verbindung am Schloss-Symbol in deiner
        Browser-Zeile und am Präfix „https://".
      </p>

      <h2>10. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie
        stets den aktuellen rechtlichen Anforderungen entspricht oder um
        Änderungen unserer Leistungen umzusetzen. Für deinen erneuten Besuch
        gilt dann die neue Datenschutzerklärung.
      </p>
    </LegalLayout>
  );
}
